module.exports = __webpack_public_path__ + "img/motor_no14.a08cd6ee.jpg";